export default __webpack_public_path__ + "static/media/alert_coppy_msg.3a4f7e8c.png";